module.exports = __webpack_public_path__ + "img/icon-setting.5bf379d.svg";